import { i18n } from '@/main';
import {getEditGridColumn} from '@/pro/components/product/common/girdColumns/ProductEdit';
import {getCopyGridColumn} from '@/pro/components/product/common/girdColumns/ProductCopy';
import {
  getBrandNameColumn,
  getCommonGridColumns, getDeliveryColumns,
  getDiscountColumns,
  getDisplayCategoryNamesColumn, getOptionColumn,
  getProductColumns,
  getSalePeriodColumn
} from '@/pro/components/product/common/girdColumns/ProductCommonGridColumns';
import {getStockCountColumn} from '@/pro/components/product/common/girdColumns/StockCount';
import {getSupplyPriceHeader} from '@/pro/components/product/common/girdColumns/ProductSupplyPrice';

// noinspection TypeScriptUnresolvedFunction
export const gridProps = {
  columns: [
    getEditGridColumn(),
    getCopyGridColumn(),
    ...getProductColumns(),
    //판매기간
    getSalePeriodColumn(),
    //전시카테고리
    getDisplayCategoryNamesColumn(),
    ...getDiscountColumns(),
    //옵션
    getOptionColumn(),
    //재고수량
    getStockCountColumn(),
    ...getCommonGridColumns(),
    ...getDeliveryColumns(),
    //브랜드
    getBrandNameColumn(),
  ],
  header: {
    height: 50,
    columns: [getSupplyPriceHeader()],
  },
  options: {
    scrollY: true,
    heightResizable: true,
    columnOptions: {
      resizable: true,
    },
  },
};

export const containerOptions = () => {
  return {
    showsRightArea: false,
    headerTooltipOption: [
      {
        id: '#supplyPrice',
        popupData: { data: { message: i18n.t('PRO_PRODUCT_PRODUCT_SUPPLY_PRICE_HELP') } },
      },
    ],
  };
};
